import { Ground, Skybox } from "@objects/terrain";
class TerrainManager {
    static instance;
    ground;
    skybox;
    /**
     * TerrainManager is a container which holds the environment (ground, structures, vegetation, and other static objects).
     * @param scene the rendering scene.
     * @param physicsWorld the physics world.
     * @param assetLoader An object containing all the game's assets.
     */
    constructor(scene, physicsWorld, assetLoader) {
        this.ground = Ground.getInstance(scene, physicsWorld, assetLoader);
        this.skybox = Skybox.getInstance(scene, assetLoader);
    }
    static getInstance(scene, physicsWorld, assetLoader) {
        if (!TerrainManager.instance)
            TerrainManager.instance = new TerrainManager(scene, physicsWorld, assetLoader);
        return TerrainManager.instance;
    }
    get getGround() {
        return this.ground;
    }
}
export default TerrainManager;
